import {DEFAULT_PLANT_CONFIG} from '../common/constants'
import {PlantConfig} from '../declarations'

import {usePlant} from './usePlant'

export const usePlantConfig: () => PlantConfig = () => {
  const plant = usePlant()
  return plant?.config ?? DEFAULT_PLANT_CONFIG
}
